import { render, staticRenderFns } from "./ThematicTagList.vue?vue&type=template&id=98795d82&scoped=true&"
import script from "./ThematicTagList.vue?vue&type=script&lang=js&"
export * from "./ThematicTagList.vue?vue&type=script&lang=js&"
import style0 from "./ThematicTagList.vue?vue&type=style&index=0&id=98795d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98795d82",
  null
  
)

export default component.exports